import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger, Col, strong, Row } from 'react-bootstrap';
import s from './PaperTile.scss';
import profil_zaufany_jpg from './profil-zaufany.jpg';
import wezel_krajowy_png from './wezelkrajowy.png';

import { notFoundImageURL } from '../../config';
import Link from '../Link';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';

const fontIcons = [
  { NrIPowDzialkiInfo: 'fa-map-o' },
  { WlasnoscDzialkiInfo: 'fa-info-circle' },
  { ZagospDzialkiInfo: 'fa-map-o' },
  { PrzebiegDrogiInfo: 'fa-road' },
  { ZimoweUtrzymanieDrog: 'fa-road' },
  { PobierzWMSiWFS: 'fa-file-text-o' },
  { ZaswiadczenieMPZP: 'fa-file-text-o' },
  { WypisIWyrysZeStudium: 'fa-file-text-o' },
  { WypisIWyrysZMpzp: 'fa-file-text-o' },
  { Undefined: 'fa-file-text-o' },
];

class PaperTile extends Component {
  state = {
    colors: 'normal',
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = headerStyle[colors];
    }
    this.setState({ colors, style });
  }
  fontIconType = (docType) => {
    let chosenFontIcon;
    fontIcons.map((item) => {
      if (Object.keys(item) == docType) chosenFontIcon = Object.values(item);
    });
    if (chosenFontIcon === undefined) {
      return fontIcons[fontIcons.length - 1].Undefined;
    } else {
      return chosenFontIcon;
    }
  }
  render() {
    const popoverTop = (
      <Popover id="popover-positioned-top" title="E-Usługa">
        Dokument wymaga zalogowania {this.props.wkLogin ? "przez Węzeł Krajowy" : "do profilu zaufanego"}
      </Popover>
    );

    const disabledEusluga = (
      <Popover id="popover-positioned-top" title="Informacja">
        E-usługa tymczasowo wyłączona
      </Popover>
    );
    // Euslugi ktore maja miec ikonke epuapu
    const euslugi = ['invest_contact',
                    'ZaswiadczenieMPZP',
                    'WypisIWyrysZeStudium',
                    'WypisZeStudium',
                    'WyrysZeStudium',
                    'WypisZMpzp',
                    'WypisIWyrysZMpzp',
                    'ZaswiadczenieStudium',
                    'ZmianaWarunkowZabudowy',
                    'ZmianaCeluPublicznego',
                    'ZezwolenieAlkohol',
                    'UstalenieNumeruPorzadkowego',
                    'ZmianaMPZP',
                    'OplataPlanistyczna',
                    'SporzadzenieMPZP',
                    'UsuniecieDrzew',
                    'DecyzjeWZ',
                    'DecyzjeULICP',
                    'ZaswiadczenieEMUIA',
                    'ZmianaSUIKZP'
                  ]
    const profZaufany = this.props.epuap
    ? (
      (this.props.disabled) ? null : (
        <OverlayTrigger trigger={['hover']} placement="top" overlay={popoverTop}>
          <img src={this.props.wkLogin ? wezel_krajowy_png : profil_zaufany_jpg} role="presentation" className={this.props.wkLogin ? "wk-jpg" : "zaufany-jpg"} />
        </OverlayTrigger>
      )
    ) : null;

    const paperTileInConst = (
      <Link to={(this.props.disabled) ? null : this.props.href}>
        <div
          className={(this.props.disabled) ? 'paper-tile-gray' : 'paper-tile'}
          style={this.state.style}
        >
          <div className="col-xs-4 center-items">
            {this.props.herb ?
              <img className="herb-gmina" src={this.props.herb} style={this.props.herb === notFoundImageURL ? { marginLeft: '8px' } : null} alt="herb gminy" />
              :
              <div className="horizontal-items">
                <i className={`fa ${this.fontIconType(this.props.epuap)} fa-4x`} aria-hidden="true" />
                { profZaufany }
              </div>
            }
          </div>
          <div className="col-xs-8 center-items">
            <strong style={this.props.text.length > 80 ? { fontSize: '10px' } : {}}>{this.props.text}</strong>
          </div>
        </div>
      </Link>
    )
    return (
      (this.props.disabled) ? (<OverlayTrigger trigger={['hover']} placement="top" overlay={disabledEusluga}>
        {paperTileInConst}
      </OverlayTrigger>) : paperTileInConst
    );
  }
}

PaperTile.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
  herb: PropTypes.string,
};

export default withStyles(s)(PaperTile);



// WEBPACK FOOTER //
// src/components/PaperTile/PaperTile.js